<template>
    <div>
        <v-row v-if="loading">
            <v-col cols="12" sm="6" offset-sm="3">
                <v-card>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-progress-linear :indeterminate="true"></v-progress-linear>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <no-team v-else-if="user !== null && user.teamId === null"></no-team>
        <my-team v-else></my-team>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import NoTeam from '../components/Team/NoTeam'
    import MyTeam from '../components/Team/MyTeam'
    import { MY_TEAM_REQUEST } from '../store/actions/team'

    export default {
        components: {
            NoTeam,
            MyTeam,
        },
        data () {
            return {
                loading: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
                team: state => state.team.myTeam,
            }),
        },
        watch: {
            user: {
                handler (user) {
                    if (user !== null && user.teamId !== null && this.team === null) {
                        this.$store.dispatch('team/' + MY_TEAM_REQUEST);
                    }
                },
                deep: true,
            },
        },
        async mounted () {
            if (this.user !== null && this.user.teamId !== null && this.team === null) {
                try {
                    this.loading = true;
                    await this.$store.dispatch('team/' + MY_TEAM_REQUEST);
                } catch (e) {
                    this.$toast.error('Došlo k chybě při načítání týmu.');
                } finally {
                    this.loading = false;
                }
            }
        },
    }
</script>
